/**
 * In-memory Arrow detail table for builder block outputs (not stored in Redux).
 * Keyed by block + scenario so navigation clears stale grids.
 */

import type { Table } from 'apache-arrow';

type StoreKey = string;

export type BuilderBlockDetailMeta = {
  indicatorColumn: string;
  dimColumns: string[];
  numRows: number;
};

const tables = new Map<StoreKey, Table>();
const metaByKey = new Map<StoreKey, BuilderBlockDetailMeta>();

export function builderDetailStoreKey(blockId: number | string, scenarioId: number): StoreKey {
  return `${blockId}:${scenarioId}`;
}

export function setBuilderBlockDetailTable(
  blockId: number | string,
  scenarioId: number,
  table: Table,
  meta?: BuilderBlockDetailMeta,
): void {
  const key = builderDetailStoreKey(blockId, scenarioId);
  tables.set(key, table);
  if (meta) {
    metaByKey.set(key, meta);
  }
}

export function getBuilderBlockDetailTable(
  blockId: number | string,
  scenarioId: number,
): Table | undefined {
  return tables.get(builderDetailStoreKey(blockId, scenarioId));
}

export function getBuilderBlockDetailMeta(
  blockId: number | string,
  scenarioId: number,
): BuilderBlockDetailMeta | undefined {
  return metaByKey.get(builderDetailStoreKey(blockId, scenarioId));
}

export function clearBuilderBlockDetailTable(blockId: number | string, scenarioId: number): void {
  const key = builderDetailStoreKey(blockId, scenarioId);
  tables.delete(key);
  metaByKey.delete(key);
}
